import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";

import "@/App.css";

import SmoothScroll from "@/components/layout/SmoothScroll";
import Nav from "@/components/layout/Nav";
import Footer from "@/components/layout/Footer";
import { AuthProvider } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";

import Home from "@/pages/Home";
import Portfolio from "@/pages/Portfolio";
import ProjectDetail from "@/pages/ProjectDetail";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Booking from "@/pages/Booking";
import { Privacy, Terms, NotFound } from "@/pages/StaticPages";

import AdminLayout from "@/pages/admin/AdminLayout";
import AdminLogin from "@/pages/admin/AdminLogin";
import Dashboard from "@/pages/admin/Dashboard";
import AdminEnquiries from "@/pages/admin/AdminEnquiries";
import AdminPackages from "@/pages/admin/AdminPackages";
import AdminProjects from "@/pages/admin/AdminProjects";
import AdminContent from "@/pages/admin/AdminContent";
import AdminAvailability from "@/pages/admin/AdminAvailability";
import { AdminTestimonials, AdminFAQs } from "@/pages/admin/AdminSimpleLists";

export default function App() {
  return (
    <div className="App bg-ink text-ivory">
      <div className="grain-layer" aria-hidden="true" />
      <BrowserRouter>
        <AuthProvider>
          <SiteProvider>
            <SmoothScroll>
              <Nav />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/portfolio" element={<Portfolio />} />
                <Route path="/portfolio/:slug" element={<ProjectDetail />} />
                <Route path="/services" element={<Services />} />
                <Route path="/services/:slug" element={<ServiceDetail />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/booking" element={<Booking />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />

                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminLayout />}>
                  <Route index element={<Dashboard />} />
                  <Route path="enquiries" element={<AdminEnquiries />} />
                  <Route path="packages" element={<AdminPackages />} />
                  <Route path="projects" element={<AdminProjects />} />
                  <Route path="testimonials" element={<AdminTestimonials />} />
                  <Route path="faqs" element={<AdminFAQs />} />
                  <Route path="content" element={<AdminContent />} />
                  <Route path="availability" element={<AdminAvailability />} />
                </Route>

                <Route path="*" element={<NotFound />} />
              </Routes>
              <Footer />
              <Toaster position="bottom-center" theme="dark" />
            </SmoothScroll>
          </SiteProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
